<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="محمد-بن-محمد-منير-محروقة">
<h1><span dir="rtl">محمد بن محمد منير محروقة</span></h1>
<blockquote>
<div class="figure">
<p style="text-align: center;"><img alt="" src="media/file1.jpg" style="width:1.73128in;height:1.84721in"/></p>
<p class="caption">A person in a suit Description automatically generated</p>
</div>
</blockquote>
<p style="text-indent:0em;"><span dir="rtl">محمد بن محمد منير محروقة مِن مواليد دمشق 1956 بسوريا، تعلَّم بمدارسها، وحصل على البكالوريوس بالعلوم الفيزيائيَّة والكيميائيَّة في جامعة دمشق عام 1979- 1980.</span></p>
<br/>
<p style="text-indent:0em;"><span dir="rtl"> عملَ أستاذًا للفيزياء والكيمياء وبمُختبرات التحليل الإشعاعي بالوقاية الإشعاعيَّة في بعض الدول العربية.</span></p>
<br/>
<p style="text-indent:0em;"><span dir="rtl">ساهَم بإنشاء مختبرات مطيافية جاما لمراقبة تسرُّب الإشعاع للغذاء والبيئة.</span></p>
<p style="text-indent:0em;"><span dir="rtl"> عضو في كثير منَ اللِّجان المتخصِّصة بالوقاية الإشعاعية وفِرَق العمل لوَضعِ اللوائح التنظيمية للإشعاع المؤيّن والإشعاع البيئي.</span></p>
<br/>
<p style="text-indent:0em;"><span dir="rtl">لدَيه خبرة في استعراض الدراسات البيئية لتقييم الآثار البيئية، وإصدار التصاريح البيئية للمشروعات التنمويَّة، وتنفيذ زيارات تفتيشية لمواقع المشروعات والمحميَّات.</span></p>
<br/>
<p style="text-indent:0em;"><span dir="rtl">خبير مؤهَّل بالوقاية الإشعاعية "</span>FANR-037QE<span dir="rtl">" بدولة الإمارات العربية المتحدة</span>.</p>
<p style="text-indent:0em;"><span dir="rtl">له اهتمامات بإلقاء المحاضرات بالوقاية الإشعاعية، واهتمامات بسلوك الأعداد، ومواهب شِعرية فردية، ومواهب بالرياضة والشطرنج.</span></p>
<br/>
<p style="text-indent:0em;"><span dir="rtl">حصل على العديد مِن الجوائز، أهمُّها جائزة الدانة الذهبية - الفئة التخصُّصيَّة، ووسام الخدمة الطويلة مِن هيئة حكومية بإمارة أبوظبي، ودرع المجلس الأعلى للأمن الوطني.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?613417ec